import { createSlice } from "@reduxjs/toolkit";

const servicesFeature = createSlice({
    name: 'services',
    initialState: {
        services: []
    },
    reducers: {
       setServices: (state, action) => {
            state.services = action.payload
       }
    }
});

export const { setServices } = servicesFeature.actions;
export default servicesFeature.reducer;